import {
  ModAlgorithm,
  Weight,
  WeightTableItem,
} from '@formunauts/banking/domain';
import {
  CountryBankDataFactory,
  provideBankingDataAccess,
  withBanks,
  WithIban,
  withSortCodes,
} from '@formunauts/shared/banking/data-access';
import * as Arr from 'effect/Array';
import * as Option from 'effect/Option';
import { banks } from './data/banks';
import ukWeightTable from './l10n/gb/gb.sort-code-weight-table.json';

export function provideAppPayment() {
  return provideBankingDataAccess(
    withSortCodes({
      weightTable: () => Arr.map(ukWeightTable.data, parseWeightTable),
    }),
    WithIban(),
    withBanks({
      bankRegistry: () =>
        new Map(
          Object.entries(banks).map(([key, data]) => [
            key,
            CountryBankDataFactory(key, data),
          ]),
        ),
    }),
  );
}

function parseWeightTable(
  weightTableItem: WeightTableFileItem,
): WeightTableItem {
  const { algorithm, exception, sortCodeRange, weight } = weightTableItem;
  return {
    algorithm: algorithm as ModAlgorithm,
    exception: Option.fromNullable(exception),
    sortCodeRange,
    weight,
  };
}

interface WeightTableFileItem {
  algorithm: string;
  exception: string | null;
  sortCodeRange: { start: string; end: string };
  weight: Weight;
}
